module.exports = __webpack_public_path__ + "img/gb91.prt.1ddb6743.jpg";